import React, { useState, useEffect } from 'react';
import { API_URL } from '../../utils/api';
import './MatchDrop.css';

const RARITY_COLORS = {
  consumer: '#B0C3D9',
  industrial: '#5E98D9',
  mil_spec: '#4B69FF',
  restricted: '#8847FF',
  classified: '#D32CE6',
  covert: '#EB4B4B',
  contraband: '#E4AE39',
};

const MatchDrop = ({ matchId, onLoaded, onDropData }) => {
  const [drop, setDrop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/drops/match/${matchId}`)
      .then(res => res.json())
      .then(data => {
        const d = data?.drop || data?.prize ? data : null;
        const visible = d && d.is_resolved;
        setDrop(d);
        setLoading(false);
        if (onLoaded) onLoaded(!!visible);
        if (onDropData && visible) onDropData(d);
      })
      .catch(() => {
        setLoading(false);
        if (onLoaded) onLoaded(false);
      });
  }, [matchId, onLoaded, onDropData]);

  if (loading || !drop || !drop.is_resolved) return null;

  const prize = drop.prize || {};
  const rarity = prize.rarity || 'mil_spec';
  const borderColor = RARITY_COLORS[rarity] || '#4B69FF';

  return (
    <div className="match-drop" style={{ border: `2px solid ${borderColor}` }}>
      <div
        className="match-drop-glow"
        style={{
          background: `radial-gradient(circle at center, ${borderColor}15 0%, transparent 50%)`,
        }}
      />
      <div className="match-drop-content">
        <div className="match-drop-label">🎁 Skin Drop</div>

        {prize.image_url && (
          <img
            className="match-drop-image"
            src={prize.image_url}
            alt={prize.display_name}
            style={{ filter: `drop-shadow(0 0 8px ${borderColor}80)` }}
          />
        )}

        <div className="match-drop-info">
          <div className="match-drop-name">
            {prize.stattrak && <span className="match-drop-stattrak">StatTrak™</span>}
            {prize.name}
          </div>
          <div className="match-drop-meta" style={{ color: borderColor }}>
            {prize.condition_display} · {prize.rarity_display}
          </div>
          {prize.estimated_value_sek && (
            <div className="match-drop-value">~{prize.estimated_value_sek} SEK</div>
          )}
        </div>

        <div className="match-drop-winner-badge" style={{ borderColor }}>
          <span className="match-drop-winner-icon">🏆</span>
          <span className="match-drop-winner-name">{drop.winner_name}</span>
        </div>
      </div>
    </div>
  );
};

export default MatchDrop;
